import axios from "axios";
import { ACCESS_TOKEN_KEYWORD, IRS_GATEWAY_ENDPOINT, IRS_GATEWAY_REPORT_ENDPOINT, IRS_GATEWAY_WALLET_ENDPOINT } from "../constant"

const TIME_OUT_IN_MILLIS = 60000;
const TIME_OUT_IN_MILLIS_IRS_REPORT = 300000;
const AUTH_BEARER_HEADER = "Bearer ";

function getHeaders() {
    const accessToken = localStorage.getItem(ACCESS_TOKEN_KEYWORD);
    return {
        "Content-Type": "application/json",
        "channel": "ADMIN_WEB",
        "Authorization": AUTH_BEARER_HEADER + accessToken
    }
}

function getOptions() {
    return {
        timeout: TIME_OUT_IN_MILLIS,
        headers: getHeaders()
    };
}

function getOptionsReport() {
    return {
        timeout: TIME_OUT_IN_MILLIS_IRS_REPORT,
        headers: getHeaders()
    };
}

function populateSearchKycProfileResponseTemplate() {
    return {
        data: [],
        totalResults: 0,
        error: null
    };
}

function populateUpdateProfileStatusResponseTemplate() {
    return {
        updatedActiveStatus: false,
        error: null
    }
}

function populateGetImageListResponseTemplate() {
    return {
        imageList: [],
        error: null
    }
}

function populateDownloadImageResponseTemplate() {
    return {
        image: null,
        index: 0
    }
}

function populateSearchHistoryLogResponseTemplate() {
    return {
        data: [],
        error: null
    };
}

function populateResponseTemplate() {
    return {
        data: [],
        error: null
    };
}


function exceptionErrorHandler(ex, errorResponse) {
    if (ex.response) {
        const response = ex.response;
        if (response.status === 401) {
            errorResponse.error = {
                errorCode: response.status.toString(),
                errorMessage: "Session Timeout",
            };
        }
        else if (response.status === 400) {
            const responseBody = response.data;
            if (responseBody.constructor === {}.constructor) {
                const { status } = responseBody;
                if (status) {
                    if (status["code"] === "4001" || status["code"] === "2011") {
                        const { code, message } = status;
                        errorResponse.error = {
                            errorCode: code,
                            errorMessage: message,
                        };
                    }
                }
            }
        }
        else if (response.status === 500) {
            errorResponse.error = {
                errorCode: response.status.toString(),
                errorMessage: "System Error",
            };
        } else {
            // If response body is not in JSON object, skip the process.
            const responseBody = response.data;
            if (responseBody.constructor === ({}).constructor) {
                const {
                    status
                } = responseBody;

                if (status) {
                    const {
                        code,
                        message
                    } = status;
                    errorResponse.error = {
                        errorCode: code,
                        errorMessage: message
                    };
                }
            }
        }
    }

    // If "errors" field is still empty, assign default error.
    if (!errorResponse.error) {
        errorResponse.error = {
            errorCode: ex.response ? ex.response.status.toString() : "500",
            errorMessage: "Unable to retrieve data. Please try again later.",
        };
    }

    return errorResponse;
}

export function searchKycUserProfile(searchKycRequestBody) {

    const options = getOptions();

    return axios.post(IRS_GATEWAY_REPORT_ENDPOINT + "/v3/report/kyc-document-upload", searchKycRequestBody, options)
        .then(
            (response) => {
                const responseResult = populateSearchKycProfileResponseTemplate();
                const responseBody = response.data;
                let needToAssignError = true;

                // If response body is not in JSON object, skip the process.
                if (responseBody.constructor === ({}).constructor) {
                    const {
                        status,
                        data
                    } = responseBody;
                    if (status) {
                        if (status["code"] === "0") {
                            const {
                                totalResults,
                                content
                            } = data;
                            responseResult.data = content;
                            responseResult.totalResults = totalResults;
                        } else {
                            responseResult.error = {
                                errorCode: status["code"],
                                errorMessage: status["message"]
                            };
                        }
                        needToAssignError = false;
                    }
                }

                // Populate error response if necessary.
                if (needToAssignError) {
                    responseResult.error = {
                        errorCode: response.status.toString(),
                        errorMessage: "Unable to retrieve data. Please try again later."
                    };
                }

                return responseResult;
            }
        ).catch(
            (ex) => {
                const errorResponse = populateSearchKycProfileResponseTemplate();
                return exceptionErrorHandler(ex, errorResponse);
            }
        );
}

export function updateActiveProfileStatus(transactionId, changedStatus) {
    const options = getOptions();
    const requestBody = {
        isActive: changedStatus
    };
    const urlWithPath = IRS_GATEWAY_REPORT_ENDPOINT + "/v3/sender-profiles/by-transaction-id/" + transactionId + "/status";

    return axios.patch(urlWithPath, requestBody, options)
        .then(
            (response) => {
                const responseResult = populateUpdateProfileStatusResponseTemplate();
                const responseBody = response.data;
                let needToAssignError = true;

                // If response body is not in JSON object, skip the process.
                if (responseBody.constructor === ({}).constructor) {
                    const {
                        status
                    } = responseBody;
                    if (status) {
                        if (status["code"] === "0") {
                            responseResult.updatedActiveStatus = !changedStatus
                        } else {
                            responseResult.updatedActiveStatus = changedStatus;
                            responseResult.error = {
                                errorCode: status["code"],
                                errorMessage: status["message"]
                            };
                        }
                        needToAssignError = false;
                    }
                }

                // Populate error response if necessary.
                if (needToAssignError) {
                    responseResult.error = {
                        errorCode: response.status.toString(),
                        errorMessage: "Unable to update profile status. Please try again later."
                    };
                }

                return responseResult;
            }
        ).catch(
            (ex) => {
                const errorResponse = populateUpdateProfileStatusResponseTemplate();
                errorResponse.updatedActiveStatus = changedStatus;
                return exceptionErrorHandler(ex, errorResponse);;
            }
        )
}

export function getDocumentNameList(transactionId, senderId, type) {
    const options = getOptions();
    options["params"] = {
        senderId,
        type,
        transactionId
    };

    const url = IRS_GATEWAY_REPORT_ENDPOINT + "/v3/sender-document";

    return axios.get(url, options)
        .then(
            (response) => {
                const responseResult = populateGetImageListResponseTemplate();
                const responseBody = response.data;
                let needToAssignError = true;

                // If response body is not in JSON object, skip the process.
                if (responseBody.constructor === ({}).constructor) {
                    const {
                        status
                    } = responseBody;
                    if (status) {
                        if (status["code"] === "0") {
                            responseResult.imageList = responseBody.data;
                            if (Array.isArray(responseResult.imageList) &&
                                responseResult.imageList.length === 0) {
                                responseResult.error = {
                                    errorCode: "404",
                                    errorMessage: "No image is found with this sender ID"
                                };
                            }
                        } else {
                            responseResult.error = {
                                errorCode: status["code"],
                                errorMessage: status["message"]
                            };
                        }
                        needToAssignError = false;
                    }
                }

                // Populate error response if necessary.
                if (needToAssignError) {
                    responseResult.error = {
                        errorCode: response.status.toString(),
                        errorMessage: "Unable to get image list. Please try again later."
                    };
                }

                return responseResult;
            }
        ).catch(
            (ex) => {
                const errorResponse = populateGetImageListResponseTemplate();
                return exceptionErrorHandler(ex, errorResponse);;
            }
        );
}

export function downloadImage(imageName, senderId, documentType, index) {
    const options = getOptions();
    options["params"] = {
        senderId: senderId,
        documentType: documentType,
        filename: imageName
    };
    options["responseType"] = "blob";

    const url = IRS_GATEWAY_REPORT_ENDPOINT + "/v3/mobile/get-document";

    return axios.get(url, options)
        .then(
            (response) => {
                const responseResult = populateDownloadImageResponseTemplate();
                responseResult.image = response.data;
                responseResult.index = index;

                return responseResult;
            }
        ).catch(
            (ex) => {
                return null;
            }
        )
}

export function getBranch() {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + "/v3/branch";
    return axios.get(url, options)
}

export function getCountry() {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + "/v3/country/tier-pricing";
    return axios.get(url, options)
}

export function getExchangeRateByCountryCode(countryCode) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + `/v3/exchange-rates/${countryCode}`;
    return axios.get(url, options)
}

export function getExchangeRate() {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + "/v3/exchange-rates";
    return axios.get(url, options)
}

export async function getExchangeRateV4(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + "/v4/exchange-rates";
    return axios.post(url, data, options)
}

export async function deleteExchangeRate(id) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + `/v4/exchange-rates?ids=${id}`;
    return axios.delete(url, options)
}

export async function createUpdateExchangeRateV4(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + `/v4/exchange-rates/add`;
    return axios.post(url, data, options)
}

export function updateExchangeRate(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + "/v3/exchange-rates";
    return axios.post(url, data, options).catch(
        (ex) => {
            const errorResponse = populateResponseTemplate();
            return exceptionErrorHandler(ex, errorResponse);
        }
    );
}

export function updateSplitFunctionConfig() {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + "/v3/config/split-function";
    return axios.put(url, {}, options)
}

export function createCampaign(data) {

    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + "/v3/campaign";
    return axios.post(url, data, options).catch(
        (ex) => {
            const errorResponse = populateResponseTemplate();
            return exceptionErrorHandler(ex, errorResponse);
        }
    );
}

export function updateCampaign(id, data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + `/v3/campaign/${id}`;
    return axios.put(url, data, options).catch(
        (ex) => {
            const errorResponse = populateResponseTemplate();
            return exceptionErrorHandler(ex, errorResponse);
        }
    );
}

export function getCampaignByCountryCode(countryCode) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + `/v3/campaign/country/${countryCode}`;
    return axios.get(url, options)
}

export function getBotReport(query) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v3/bot-report/list';
    return axios.get(url, {
        ...options,
        params: query
    })
}

export function downloadBotReport(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v3/bot-report/download';
    return axios.post(url, data, {
        ...options,
        responseType: 'blob'
    })
}

export function uploadBotReport(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v3/bot-report/upload';
    return axios.post(url, data, options).catch(
        (ex) => {
            const errorResponse = populateResponseTemplate();
            return exceptionErrorHandler(ex, errorResponse);
        }
    );
}

export function searchHistoryLogTier(searchHistoryLogTierBody) {
    const options = getOptions();
    return axios.post(IRS_GATEWAY_REPORT_ENDPOINT + "/v3/campaign/history", searchHistoryLogTierBody, options)
        .then(
            (response) => {
                const responseResult = populateSearchHistoryLogResponseTemplate();
                const responseBody = response.data;
                let needToAssignError = true;

                // If response body is not in JSON object, skip the process.
                if (responseBody.constructor === ({}).constructor) {
                    const {
                        status,
                        data
                    } = responseBody;
                    if (status) {
                        if (status["code"] === "0") {
                            responseResult.data = data["pages"];
                        } else {
                            responseResult.error = {
                                errorCode: status["code"],
                                errorMessage: status["message"]
                            };
                        }
                        needToAssignError = false;
                    }
                }

                // Populate error response if necessary.
                if (needToAssignError) {
                    responseResult.error = {
                        errorCode: response.status.toString(),
                        errorMessage: "Unable to retrieve data. Please try again later."
                    };
                }

                return responseResult;
            }
        ).catch(
            (ex) => {
                const errorResponse = populateSearchHistoryLogResponseTemplate();
                return exceptionErrorHandler(ex, errorResponse);
            }
        );
}

export function getService() {
    const options = getOptions();
    const url = IRS_GATEWAY_ENDPOINT + '/v3/service';
    return axios.get(url, options)
}

export function getIrsRemittanceReport(data) {
    const options = getOptionsReport();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v3/get-irs-remittance-info';
    return axios.post(url, data, options)
}

export function getIrsRemittanceReportFile(data) {
    const options = getOptionsReport();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v3/get-irs-remittance-info/report';
    return axios.post(url, data, {
        ...options,
        responseType: 'blob'
    })
}

export function getLocation(countryCode = "66") {
    const options = getOptions();
    const data = {
        country_code: countryCode,
        location_search_string: "",
        location_level: 3
    }
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v3/get-locations-allow-empty';
    return axios.post(url, data, options)
}

export function resendSMS(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v3/transfer/resend-sms';
    return axios.post(url, data, options)
}

export function cancelTransfer(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v4/transfer/agent/cancel';
    return axios.post(url, data, options)
}

export function cancelTransferWallet(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_WALLET_ENDPOINT + '/internal/v2/irs/transfer/cancel';
    return axios.post(url, data, options)
}

export function getSlip(transactionId, query = {}) {
    const options = getOptions();
    const url = `${IRS_GATEWAY_REPORT_ENDPOINT}/v3/transfer/transaction/${transactionId}/slip`;
    return axios.get(url, {
        ...options,
        params: query
    })
}

export function createBankCostRate(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v3/bank-cost-rate';
    return axios.post(url, data, options)
}

export function checkExistBankCostRate(date, countryCode) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + `/v3/bank-cost-rate/transaction-date/${date}/country-code/${countryCode}`;
    return axios.get(url, options)
}

export function getBankCostRate(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v3/bank-cost-rate/history';
    return axios.post(url, data, options)
}

/**
 * Uploads a file containing special customer data in bulk to the IRS admin.
 *
 * @param {File} file - The file to be uploaded.
 * @returns {Promise} - A promise that resolves to the response of the upload request.
 */
export function specialCustomerBulkUpload(file) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v1/exchange-rates/special-customers/bulk-upload';
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(url, formData, {
        ...options,
        headers: {
            ...options.headers,
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function searchSpecialCustomer(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v1/special-customer/search';
    return axios.post(url, data, options)
}

export function createUpdateSpecialCustomer(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v1/special-customer';
    return axios.post(url, data, options)
}

export function deleteSpecialCustomer(data) {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v1/special-customer';
    return axios.delete(url, { ...options, data })
}

export function getSpecialCustomerUpdatedByUsers() {
    const options = getOptions();
    const url = IRS_GATEWAY_REPORT_ENDPOINT + '/v1/special-customer/updated-by-users';
    return axios.get(url, options);
}
